<template>
    <v-container
        :id="
            section.columnId && section.columnId[$i18n.locale]
                ? section.columnId[$i18n.locale].current
                : section._key
        "
        :fluid="section.fullWidth"
        :class="{
            'section-content-columns': true,
            'pb-0': section.removePadding,
            'col--xs': $vuetify.breakpoint.xsOnly,
            'col--sm': $vuetify.breakpoint.smOnly,
            'col--md': $vuetify.breakpoint.mdOnly,
            'col--lg': $vuetify.breakpoint.lgOnly,
            'col--xl': $vuetify.breakpoint.xlOnly,
            'col--sm-and-down': $vuetify.breakpoint.smAndDown,
        }"
    >
        <v-row column justify-center align-center>
            <v-col
                v-for="column in section.content"
                :key="column._key"
                :cols="column.mobileWidth ? column.mobileWidth : '12'"
                :md="column.tabletWidth ? column.tabletWidth : '12'"
                :lg="column.desktopWidth ? column.desktopWidth : '12'"
                :class="`content-column${column.dense ? ' dense' : ''} ${
                    section.removePadding ? 'px-0 pb-0' : ''
                } ${
                    column.verticalAlignment
                        ? `d-flex align-${column.verticalAlignment}`
                        : ''
                } ${column._type === 'columnDynamic' ? 'd-flex align-center justify-center': ''}`
                "
            >
                <ColumnBackgroundImage
                    v-if="column._type === 'columnBackgroundImage'"
                    :content="column"
                />
                <ColumnForm
                    v-if="column._type === 'columnForm'"
                    :content="column"
                />
                <ColumnHeadingBlurbLink
                    v-if="column._type === 'columnHeadingBlurbLink'"
                    :content="column"
                />
                <HtmlContent
                    v-if="column._type === 'columnHtmlContent'"
                    :content="column"
                    context="column"
                />
                <ColumnImageBlurb
                    v-if="column._type === 'columnImageBlurb'"
                    :content="column"
                />
                <ColumnDynamic
                    v-if="column._type === 'columnDynamic'"
                    :content="column"
                />
                <EmbedEbook
                    v-if="column._type === 'columnEbook'"
                    :url="column.eBook.url"
                    :height="column.eBook.height"
                    :maxWidth="column.eBook.maxWidth"
                />
                <ContactPoints
                    v-if="column._type === 'columnContactPoints'"
                    :content="column"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ColumnBackgroundImage from '~/components/ColumnBackgroundImage'
import ColumnForm from '~/components/ColumnForm'
import ColumnHeadingBlurbLink from '~/components/ColumnHeadingBlurbLink'
import ColumnImageBlurb from '~/components/ColumnImageBlurb'
import ColumnDynamic from '~/components/ColumnDynamic'
import HtmlContent from '~/components/HtmlContent'
import ContactPoints from '~/components/ContactPoints'
import EmbedEbook from '~/components/embeds/EmbedEbook.vue'
export default {
    name: 'ContentColumns',
    components: {
        ColumnBackgroundImage,
        ColumnForm,
        ColumnHeadingBlurbLink,
        ColumnImageBlurb,
        HtmlContent,
        EmbedEbook,
        ColumnDynamic,
        ContactPoints,
    },
    props: {
        section: {
            type: Object,
            default: null,
        },
    },
    computed: {},
}
</script>
